var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.verificationStatusLoaded
    ? _c(
        "div",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.left",
              value: _vm.tooltipText,
              expression: "tooltipText",
              modifiers: { left: true },
            },
          ],
          staticClass: "vertical-center",
        },
        [
          _c("span", { staticClass: "font-italic" }, [
            _vm._v("\n    " + _vm._s(_vm.verificationStatus) + "\n  "),
          ]),
          _vm._v(" "),
          _c("icon", {
            staticClass: "p-2 fa-lg",
            class: _vm.IS_EXPERT_PROFILE_NUMBER_VERIFIED
              ? "text-success"
              : "text-danger",
            attrs: {
              name: _vm.IS_EXPERT_PROFILE_NUMBER_VERIFIED
                ? "check-circle"
                : "times-circle",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }